module.exports = __webpack_public_path__ + "media/pied-billed-grebe-2.79fdce40.mp3";